import React from 'react'
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom'
import { LoanRequestFlow } from './views'
import { Layout, PageNotFound } from '~/components'

export const Application: React.FC = () => {
  const match = useRouteMatch()

  return (
    <Layout>
      <Switch>
        <Route path={`${match.url}/loan-request`}>
          <LoanRequestFlow />
        </Route>
        <Route path={`${match.url}/`} exact>
          <Redirect to={`${match.url}/loan-request`} />
        </Route>
        <Route path='*'>
          <PageNotFound
            returnPath={'/'}
            description='A página que você está procurando não existe. Por favor verifique a sua URL ou se você continuar tendo problemas, volte para a solitação de empréstimo:'
            buttonProps={{
              icon: 'LayersIcon',
              text: 'Ir para solitação de empréstimo'
            }}
          />
        </Route>
      </Switch>
    </Layout>
  )
}
